export const config = {
    // URL_API: 'http://logistica.grupospessot.com.ar/api',
    URL_API: 'https://transporteylogisticamp.com.ar/api',
}